import * as sharedTypes from 'src/actions/shared/sharedTypes';
import ComplianceLogEvent from './complianceEvent';
import createCollectionResource from 'src/actions/shared/createResource';
import emptyObserverCreator from 'src/actions/shared/emptyObserverCreator';

const complianceEventsResource = createCollectionResource<ComplianceLogEvent>({
  name: 'complianceEvents',
  endpoint: 'v1/orgs/:orgId/compliance/events',
  observerCreator: emptyObserverCreator,
});

const fetch: sharedTypes.AppThunk =
  ({ identifier }: { identifier: string }) =>
  async (dispatch, getState, { gateways }) => {
    try {
      dispatch(fetchStarted({}));

      const result = await gateways.complianceEvents.fetchAll({ params: { filter: identifier } });
      dispatch(fetchSuccess(result));
    } catch (err) {
      dispatch(fetchRequestError({}));
    }
  };

const { fetchStarted, fetchSuccess, fetchRequestError } = complianceEventsResource.actions;

complianceEventsResource.effects.fetch = fetch;

export default complianceEventsResource;
